import { faCheck, faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge } from 'components/badge/Badge';
import { ButtonNew } from 'components/buttonNew';
import { t } from 'i18next';
import React, { useState } from 'react';

interface IAccordionItem {
  success_badge: boolean;
  success_preview?: React.JSX.Element;
  badge?: string;
  title: string;
  content: React.JSX.Element;
  onSave?: () => boolean;
}

interface IPageProps {
  items: IAccordionItem[];
}

interface IState {
  openItems: number[];
}

export default function Accordion({ items }: IPageProps) {
  const [state, setState] = useState<IState>({
    openItems: [],
  });

  function toggleItem(item: IAccordionItem, i: number) {
    if (state.openItems.includes(i)) {
      setState({ openItems: state.openItems.filter(openIndex => openIndex !== i) });
    } else {
      setState({ openItems: [i] });
    }
  }

  function handleSave(item: IAccordionItem, i: number) {

    if (item.onSave) {
      const successful = item.onSave();
      if (successful) {
        toggleItem(item, i);
      }
    }
  }

  return <div className="mt-2">
    {items.map((item, i) => {
      const isOpen = state.openItems.includes(i);

      return <div className="py-4 px-6 border-b border-l border-r border-gray-200 first:rounded-t-2xl first:border-t last:rounded-b-2xl " key={item.title}>
        <div className="flex justify-between items-center cursor-pointer" onClick={() => toggleItem(item, i)}>
          <div className="flex flex-col gap-2">
            <div>
              <Badge type={item.success_badge ? 'success' : 'gray'} className="shrink">
                {item.success_badge && <FontAwesomeIcon icon={faCheck} className="pr-1" />}
                {item.badge}
              </Badge>
            </div>
            {item.title}
            {item.success_badge && item.success_preview}
          </div>
          <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
        </div>
        {isOpen &&
          <div className="border-t border-gray-200 mt-4 pt-4">
            {item.content}
            <div className="flex gap-2 justify-end">
              <ButtonNew type="tertiary" onClick={() => toggleItem(item, i)}>{t('Cancel')}</ButtonNew>
              <ButtonNew type="primary" onClick={() => handleSave(item, i)}>{t('Save')}</ButtonNew>
            </div>
          </div>
        }
      </div>;
    })}
  </div>;
}
